import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Tabs from "./Tabs";
import { useDesktopHeaderHeight } from "arena/components/AppShell/AppModeContext";

const SIDEBAR_WIDTH = 400;

export default function ContentDesktopSidebar({
  tabsSchema,
  tabs,
  sidebarHeader,
}) {
  const [tab, setTab] = useState(tabs[0].value);
  const headerHeight = useDesktopHeaderHeight();

  const onChangeTab = useCallback((event, tab) => {
    event.preventDefault();
    setTab(tab);
  }, []);

  // Скрываем табы только если один таб И это чат
  const shouldHideTabs = tabs.length === 1 && tabs[0].value === "CHAT";

  return (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        flexShrink: 0,
        position: "relative",
        display: { xs: "none", md: "block" },
      }}
    >
      <Box
        sx={{
          width: SIDEBAR_WIDTH,
          position: "fixed",
          top: headerHeight,
          right: 0,
          bottom: 0,
          display: "flex",
          flexDirection: "column",
          // bgcolor: "background.header",
        }}
      >
        {sidebarHeader}
        {!shouldHideTabs && (
          <>
            <Tabs tab={tab} onChangeTab={onChangeTab} tabs={tabs} />
            <Divider />
          </>
        )}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            scrollbarGutter: "stable",
          }}
        >
          {tabsSchema[tab].component}
        </Box>
      </Box>
    </Box>
  );
}

ContentDesktopSidebar.propTypes = {
  tabsSchema: PropTypes.object.isRequired,
  sidebarHeader: PropTypes.node,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
};
